import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/context/AuthContext";
import { api, errorMessage } from "@/lib/api";
import { AuthShell, FormError } from "./AuthShell";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const { reload } = useAuth();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [done, setDone] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (password.length < 8) return setError("Your password needs at least 8 characters.");
    if (password !== confirm) return setError("The two passwords don't match.");
    setBusy(true);
    try {
      await api.post("/auth/reset-password", { token: params.get("token") || "", password });
      await reload();
      setDone(true);
    } catch (err) {
      setError(errorMessage(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthShell eyebrow="Account recovery" title={done ? "Password updated" : "Choose a new password"}>
      {done ? (
        <div className="space-y-6" data-testid="reset-password-success">
          <p className="text-slate-600">Your password has been changed and you've been signed out everywhere. Sign in with your new password.</p>
          <Link to="/signin" data-testid="reset-to-signin-link" className="inline-flex h-11 items-center rounded-md bg-navy px-6 text-sm font-medium text-white hover:bg-navy-2">Sign in</Link>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-5" data-testid="reset-password-form">
          <div className="space-y-2">
            <Label htmlFor="password">New password</Label>
            <Input id="password" type="password" data-testid="reset-password-input" value={password} onChange={(e) => setPassword(e.target.value)} required autoComplete="new-password" className="h-11" />
          </div>
          <div className="space-y-2">
            <Label htmlFor="confirm">Type it again</Label>
            <Input id="confirm" type="password" data-testid="reset-password-confirm-input" value={confirm} onChange={(e) => setConfirm(e.target.value)} required autoComplete="new-password" className="h-11" />
          </div>
          <FormError message={error} testId="reset-error" />
          <Button type="submit" disabled={busy} data-testid="reset-submit-button" className="h-11 w-full bg-navy hover:bg-navy-2">
            {busy ? "Saving..." : "Save new password"}
          </Button>
        </form>
      )}
    </AuthShell>
  );
}
